import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { SiteGetSite } from '@src/services/api-client'

function SiteName({ id }) {
  const [data, setData] = useState(undefined)

  useEffect(() => {
    if (!id) {
      setData(undefined)
      return
    }

    SiteGetSite(id, {
      cache: {
        ttl: 60000 * 10,
      },
    }).then((res) => {
      setData(res.data)
    })
  }, [id])

  return <span>{data?.name}</span>
}

SiteName.propTypes = {
  id: PropTypes.string.isRequired,
}

export { SiteName }
